import React, { useCallback } from 'react';
import { Box } from '@mui/material';

export type SortDirection = 'asc' | 'desc';

export interface WcnSortIconProps {
    /** null = no active direction */
    activeDirection: SortDirection | null;
    /** null = user cleared the sort (clicked the active button again) */
    onChange: (direction: SortDirection | null) => void;
    /** Flush-aligns the icon when there is no preceding label */
    compact?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const WcnSortIcon: React.FC<WcnSortIconProps> = ({ activeDirection, onChange, compact = false, className, style }) => {
    const handleClick = useCallback(
        (dir: SortDirection, e: React.MouseEvent) => {
            e.stopPropagation();
            onChange(activeDirection === dir ? null : dir);
        },
        [activeDirection, onChange]
    );

    return (
        <Box
            className={['wcn-sort-icon', compact && 'wcn-sort-icon--compact', className].filter(Boolean).join(' ')}
            style={style}
        >
            <i
                aria-label="Sort descending"
                aria-pressed={activeDirection === 'desc'}
                className={`bi bi-caret-down-square wcn-sort-icon__btn wcn-sort-icon__btn--down ${
                    activeDirection === 'desc' ? 'active' : ''
                }`}
                onClick={(e) => handleClick('desc', e)}
            />
            <i
                aria-label="Sort ascending"
                aria-pressed={activeDirection === 'asc'}
                className={`bi bi-caret-up-square wcn-sort-icon__btn wcn-sort-icon__btn--up ${
                    activeDirection === 'asc' ? 'active' : ''
                }`}
                onClick={(e) => handleClick('asc', e)}
            />
        </Box>
    );
};

WcnSortIcon.displayName = 'WcnSortIcon';

export default WcnSortIcon;
